import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import i18n from "../i18n";

// Handles /en/* or /fr/* by switching locale and redirecting to the same path without the prefix
const LocaleRedirect = () => {
  const { locale } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale);
      localStorage.setItem("i18nextLng", locale);
    }
  }, [locale]);

  const targetPath =
    location.pathname.replace(/^\/(en|fr)/i, "") || "/";

  return (
    <Navigate
      to={`${targetPath}${location.search}${location.hash}`}
      replace
    />
  );
};

export default LocaleRedirect;
